module.exports = __webpack_public_path__ + "static/media/starmarket.ab9ec546.svg";